/**
 * ConductScoreIndicator - Visual indicator for Conduct Score (1-10 scale)
 *
 * This is a wrapper around the shared ConductScoreCircle component
 * for backwards compatibility with existing record components.
 *
 * Atomic level: Atom
 */

import React from 'react';
import {
  ConductScoreCircle,
  getConductScoreColor,
  type ConductScoreCircleProps,
} from '../../../ui/conduct-score-circle';
import type { ConductScoreBreakdown } from '../../../../types/record';

interface ConductScoreIndicatorProps {
  score: number; // 1-10 scale
  size?: 'small' | 'medium' | 'large';
  className?: string;
  tooltip?: string; // optional hover explanation
  breakdown?: ConductScoreBreakdown;
  isProcessing?: boolean;
  processingStage?: string | null;
}

// Map legacy size names to new size names
const sizeMap: Record<string, ConductScoreCircleProps['size']> = {
  small: 'sm',
  medium: 'md',
  large: 'lg',
};

const ConductScoreIndicator: React.FC<ConductScoreIndicatorProps> = ({
  score,
  size = 'medium',
  className = '',
  breakdown,
  isProcessing,
  processingStage,
}) => {
  return (
    <ConductScoreCircle
      score={score}
      size={sizeMap[size]}
      className={className}
      breakdown={breakdown}
      isProcessing={isProcessing}
      processingStage={processingStage}
    />
  );
};

export { ConductScoreIndicator, getConductScoreColor };
export default ConductScoreIndicator;
